/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDevicePushTokensPost200Response
 */
export interface UserDevicePushTokensPost200Response {
    /**
     * 
     * @type {boolean}
     * @memberof UserDevicePushTokensPost200Response
     */
    success?: boolean;
}

/**
 * Check if a given object implements the UserDevicePushTokensPost200Response interface.
 */
export function instanceOfUserDevicePushTokensPost200Response(value: object): value is UserDevicePushTokensPost200Response {
    return true;
}

export function UserDevicePushTokensPost200ResponseFromJSON(json: any): UserDevicePushTokensPost200Response {
    return UserDevicePushTokensPost200ResponseFromJSONTyped(json, false);
}

export function UserDevicePushTokensPost200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDevicePushTokensPost200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
    };
}

export function UserDevicePushTokensPost200ResponseToJSON(json: any): UserDevicePushTokensPost200Response {
    return UserDevicePushTokensPost200ResponseToJSONTyped(json, false);
}

export function UserDevicePushTokensPost200ResponseToJSONTyped(value?: UserDevicePushTokensPost200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

